import axiosLib from 'axios'
import { getSettingDevice, isStrEmpty } from '@/utils/utils'

const axiosAuth = axiosLib.create()

export function setToken(data) {
    localStorage.setItem('access_token', data)
}

export function getToken() {
    return localStorage.getItem('access_token')
}

export function getAccessToken() {
    return localStorage.getItem('access_token')
}

export function deleteToken() {
    localStorage.removeItem('access_token')
}

export const getUserInfo = () => {
    return localStorage.getItem('user_info') || ''
}

export const setUserInfo = (data) => {
    data = JSON.stringify(data)
    localStorage.setItem('user_info', data)
}

export const deleteUserInfo = () => {
    return localStorage.removeItem('user_info')
}

export const getLocale = () => {
    return localStorage.getItem('locale') || 'en'
}

function getRefreshToken() {
    return localStorage.getItem('refresh_token')
}

axiosAuth.interceptors.request.use((request) => {
    const token = getAccessToken()
    let settings: any = getSettingDevice()

    if (token) {
        request.headers.Authorization = token
        request.headers.ContentType = 'application/json'
    }
    if (!isStrEmpty(settings)) {
        settings = JSON.parse(settings)
        request.headers['Device-Network-Mac-Address'] = settings.mac
        request.headers['Device-Serial-Number'] = settings.serial
        request.headers['Device-Unique-Id'] = settings.uniqueId
        request.headers['App-Version'] = settings.appVersion
    } else {
        request.headers['Device-Network-Mac-Address'] = ''
        request.headers['Device-Serial-Number'] = ''
        request.headers['Device-Unique-Id'] =''
        request.headers['App-Version'] = ''
    }
    return request
})

axiosAuth.interceptors.response.use(
    (response) => {
        return response
    },
    (error) => {
        if (error.response && error.response.data) {
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.message)
    }
)

export default axiosAuth
